import { CASNotifications } from '../../../cimsPage/instances/cas'
import { Notifications } from '../../common'

const { Edit, View } = Notifications({
  page: CASNotifications,
  view: '2DE8BE72-B435-4BBF-8B34-F865F993643F',
  edit: 'E8995046-E752-4E5A-95B0-5C9C0D5BC7BE',
})

export const ViewCASNotification = View
export const EditCASNotification = Edit

export type CASNotificationPermission =
  | typeof ViewCASNotification
  | typeof EditCASNotification
